export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  return new Intl.NumberFormat('en-IN').format(Math.round(num));
};

export const formatDecimal = (num, decimals = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
};

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatRelativeTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(dateString);
};

export const getStatusColor = (status) => {
  const colors = {
    online: 'text-emerald-700 bg-emerald-50 border-emerald-200',
    offline: 'text-red-700 bg-red-50 border-red-200',
    partial_offline: 'text-amber-700 bg-amber-50 border-amber-200',
    draft: 'text-slate-700 bg-slate-100 border-slate-200',
    pending_approval: 'text-blue-700 bg-blue-50 border-blue-200',
    approved: 'text-emerald-700 bg-emerald-50 border-emerald-200',
    locked: 'text-slate-700 bg-slate-100 border-slate-200',
    critical: 'text-red-700 bg-red-50 border-red-200',
    warning: 'text-amber-700 bg-amber-50 border-amber-200',
    info: 'text-blue-700 bg-blue-50 border-blue-200',
  };
  return colors[status] || 'text-slate-700 bg-slate-100 border-slate-200';
};

export const getStatusLabel = (status) => {
  const labels = {
    online: 'Online',
    offline: 'Offline',
    partial_offline: 'Partial Offline',
    draft: 'Draft',
    pending_approval: 'Pending',
    approved: 'Approved',
    locked: 'Locked',
    critical: 'Critical',
    warning: 'Warning',
    info: 'Info',
  };
  return labels[status] || status;
};

export const downloadCSV = (data, filename) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};
